// extracted by mini-css-extract-plugin
export default {"overlay":"CircularProgress_overlay__2L6j5"};